import { I18n } from 'i18n-js'
import en from './translations/en.json'
import zhTW from './translations/zh-TW.json'

i18n = new I18n()
i18n.store(en)
i18n.store(zhTW)

i18n.defaultLocale = 'zh-TW'
i18n.locale = document.documentElement.getAttribute('lang') or 'zh-TW'
i18n.enableFallback = true

export default i18n
